import CKYContainer from "./CKYCContainer";
import CKYCStore from "./CKYCStore";

export default CKYCStore(CKYContainer);